import { useState } from 'react';

const FAQS = [
  {
    q: '導入までにどれくらいかかりますか',
    a: 'アカウント発行後、プロジェクト資料をアップロードし、AIの提案内容を確認することで利用を開始できます。詳細な初期設定が必要な場合は、導入支援についてお問い合わせください。',
  },
  {
    q: 'どのような資料をアップロードできますか',
    a: '企画書、提案書、WBS、議事録、仕様書、進捗表など、プロジェクトに関係する資料を想定しています。',
  },
  {
    q: 'AIが作成したタスクは自動的に確定しますか',
    a: 'いいえ。AIの提案をユーザーが確認、修正、承認してからプロジェクトへ反映します。AIはあくまで支援ツールであり、最終的な判断は人が行います。',
  },
  {
    q: '対応言語を教えてください',
    a: '日本語、英語、タイ語に対応しています。UIの表示言語をメンバーごとに切り替えることができます。',
  },
  {
    q: '日本とタイの祝日を別々に設定できますか',
    a: 'はい。メンバーごとに所属国や稼働日を設定し、それぞれの祝日を考慮して予定を管理できます。日本の祝日には日本メンバー、タイの祝日にはタイメンバーが自動で休みになります。',
  },
  {
    q: 'データは安全に管理されますか',
    a: '会社ごとにデータを分離し、Google Cloudの東京リージョンで管理します。毎日の自動バックアップと監査ログにも対応しています。',
  },
  {
    q: '無料で利用できますか',
    a: '正式導入前に無料でお試しいただけます（プロジェクト1件・メンバー3名まで／期限なし）。正式利用の開始後は月額料金が発生します。「完全無料」「永久無料」ではありません。',
  },
  {
    q: '解約方法を教えてください',
    a: '契約条件および解約方法は、正式な利用規約に基づいて案内します。詳しくはお問い合わせください。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': FAQS.map((faq) => ({
      '@type': 'Question',
      'name': faq.q,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.a,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12">
          よくある質問
        </h2>
        <div className="space-y-3">
          {FAQS.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
              <button
                className="w-full px-6 py-4 text-left flex items-center justify-between gap-4 cursor-pointer hover:bg-background-100 transition-colors"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <span className="text-sm font-medium text-foreground-800">{faq.q}</span>
                <i className={`${openIndex === idx ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500 shrink-0 transition-transform`}></i>
              </button>
              {openIndex === idx && (
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
    </section>
  );
}